import { ReactComponent as Logo } from '../../images/TellyLogo.svg'
import { useEffect, useRef } from 'react'
import {
  Container,
  Wrapper,
  Header,
  Title,
  LogoContainer,
  Main,
  Message,
  Text,
  RightBackground,
  Footer,
  GoToTellyApp,
} from '../MobileApp/MobileApp.styles'
import { isMobileUserAgent } from 'constants/appStores'
import { getRegisterMobileURI } from 'constants/mobile'

// Matches the other redirect-only pages (OpenChat, DeleteAccount, TellyPhone):
// long enough for the first paint, so the visitor sees the page rather than a
// blank frame if the app never takes over.
const DEEPLINK_DELAY_MS = 200

/**
 * Where registration links land when they can't be completed on the web.
 *
 * Deliberately a separate screen from <MobileApp /> despite the identical copy,
 * so the registration wording can change without touching the generic page.
 */
export const MobileRegister: React.FC = (): JSX.Element => {
  const anchorRef = useRef<HTMLAnchorElement>(null)

  // The hosted sign-in page's "Sign up" link lands here, so this page is a
  // hop rather than a destination — fire the deeplink instead of waiting for a
  // tap. Mobile only: on desktop `telly://` raises an unsupported-protocol
  // dialog, and the copy below already tells those visitors what to do.
  useEffect(() => {
    if (!isMobileUserAgent(navigator.userAgent)) {
      return
    }

    const timer = setTimeout(
      () => anchorRef.current?.click(),
      DEEPLINK_DELAY_MS
    )

    return (): void => clearTimeout(timer)
  }, [])

  return (
    <Wrapper>
      <Header>
        <LogoContainer>
          <Logo />
        </LogoContainer>
      </Header>

      <Main>
        <Container>
          <Title>almost there!</Title>
          <Message>
            Please open link on your mobile phone to finish setup.
          </Message>
          <Text>Make sure Telly mobile app is installed</Text>
          <GoToTellyApp ref={anchorRef} href={getRegisterMobileURI()}>
            Go to Telly Mobile App
          </GoToTellyApp>
        </Container>
        <RightBackground />
      </Main>
      <Footer />
    </Wrapper>
  )
}
